var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.TableBase,{attrs:{"items":_setup.items},scopedSlots:_vm._u([{key:"expanded-item",fn:function({ headers, item }){return [_c('td',{attrs:{"colspan":headers.length}},[_c(_setup.VacationExpandItem,{attrs:{"dat":item.dat,"approvals":item.approvals,"shift":item.shift,"affiliation":item.affiliationName}})],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }